import { render, staticRenderFns } from "./AdminTicketAttachmentList.vue?vue&type=template&id=5f44804b"
import script from "./AdminTicketAttachmentList.vue?vue&type=script&lang=js"
export * from "./AdminTicketAttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports